export const ApplicationName = 'TimeRental.Identity';

export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message'
};

export const LogoutActions = {
  LogoutCallback: 'logout-callback',
  Logout: 'logout',
  LoggedOut: 'logged-out'
};

export const LoginActions = {
  Login: 'login',
  LoginCallback: 'login-callback',
  LoginFailed: 'login-failed',
  Profile: 'profile',
  Register: 'register'
};

const prefix = 'authentication';

export const ApplicationPaths = {
  DefaultLoginRedirectPath: '{{mainApiUrl}}',
  ApiAuthorizationClientConfigurationUrl: `{{userApiUrl}}_configuration/${ApplicationName}`,
  ApiAuthorizationPrefix: `/${prefix}`,
  Login: `/${prefix}/${LoginActions.Login}`,
  RegisterCallback: `{{mainApiUrl}}${prefix}/${LoginActions.Login}`,
  LoginFailed: `/${prefix}/${LoginActions.LoginFailed}`,
  LoginCallback: `/${prefix}/${LoginActions.LoginCallback}`,
  Register: `/${prefix}/${LoginActions.Register}`,
  Profile: `/${prefix}/${LoginActions.Profile}`,
  LogOut: `/${prefix}/${LogoutActions.Logout}`,
  LoggedOut: `/${prefix}/${LogoutActions.LoggedOut}`,
  LogOutCallback: `/${prefix}/${LogoutActions.LogoutCallback}`,
  IdentityRegisterPath: '{{userApiUrl}}Account/Register',
  IdentityManagePath: '{{userApiUrl}}Account/Manage'
};
